/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  DisableCustomerMutation,
  useDisableCustomerMutation,
} from "~/generated/graphql";
import { showSuccess, showError } from "~/components";

type UseDeleteCustomerProps = {
  onSuccess: () => void;
};

export function useDeleteCustomer({ onSuccess }: UseDeleteCustomerProps) {
  const [deleteCustomerMutation, { loading }] = useDisableCustomerMutation({
    onCompleted: (data: DisableCustomerMutation) => {
      if (data.disableCustomer) {
        onSuccess();
      } else {
        showError("Something went wrong.");
      }
    },
  });

  function deleteCustomer(id: string) {
    return deleteCustomerMutation({
      variables: {
        input: {
          customerId: id,
        },
      },
    })
      .then(() => showSuccess(`Customer has been removed.`))
      .catch(() => showError("Something went wrong."));
  }

  return [deleteCustomer, { loading }] as const;
}
